import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const ZapierIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<g clipPath="url(#clip0_6363_3716)">
			<path
				fill="currentColor"
				d="M8.00438 1C8.39982 1.00073 8.78873 1.03414 9.16679 1.09734V5.17265L12.056 2.29088C12.3751 2.51752 12.6736 2.7696 12.9496 3.04492C13.2258 3.32024 13.4793 3.61881 13.7065 3.93699L10.8171 6.81876H14.9031C14.9665 7.19578 15 7.58226 15 7.97744V7.98688C15 8.38206 14.9665 8.76925 14.9031 9.14627H10.8164L13.7065 12.0273C13.4793 12.3455 13.2258 12.6441 12.9505 12.9194H12.9496C12.6736 13.1947 12.3751 13.4475 12.0568 13.6734L9.16679 10.7916V14.867C8.78943 14.9302 8.40052 14.9635 8.00508 14.9644H7.99492C7.59934 14.9635 7.21196 14.9302 6.8339 14.867V10.7916L3.94469 13.6734C3.30661 13.2209 2.74877 12.6637 2.29423 12.0273L5.18358 9.14627H1.09761C1.03351 8.76852 1 8.37987 1 7.9847V7.96441C1.00066 7.86186 1.00738 7.73658 1.01702 7.60696L1.02 7.56797C1.04856 7.20313 1.09761 6.81876 1.09761 6.81876H5.18358L2.29423 3.93699C2.52073 3.61881 2.77352 3.32097 3.04952 3.04638L3.05091 3.04492C3.32636 2.7696 3.62558 2.51752 3.94469 2.29088L6.8339 5.17265V1.09734C7.21196 1.03414 7.60018 1.00073 7.99632 1H8.00438ZM8.00368 6.23689H7.99701C7.47698 6.23689 6.97892 6.33205 6.51855 6.50494C6.34599 6.96333 6.25047 7.4602 6.24977 7.97888V7.98542C6.25047 8.5041 6.34599 9.00099 6.51924 9.45936C6.97892 9.63226 7.47698 9.72743 7.99701 9.72743H8.00368C8.52371 9.72743 9.02177 9.63226 9.48145 9.45936C9.6547 9.00026 9.75023 8.5041 9.75023 7.98542V7.97888C9.75023 7.4602 9.6547 6.96333 9.48145 6.50494C9.02177 6.33205 8.52371 6.23689 8.00368 6.23689Z"
			></path>
		</g>
		<defs>
			<clipPath id="clip0_6363_3716">
				<rect
					width="14"
					height="14"
					fill="white"
					transform="translate(1 1)"
				></rect>
			</clipPath>
		</defs>
	</svg>
))
